import { defineComponent as t, openBlock as n, createBlock as r, unref as p, mergeProps as d, withCtx as m, createElementVNode as l } from "vue";
import { RevIcon as c } from "@ds/components/Icon";
const f = /* @__PURE__ */ t({
  name: "IconMedal",
  __name: "IconMedal",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(a) {
    const o = a;
    return (i, e) => (n(), r(p(c), d(o, { "view-box": "0 0 24 24" }), {
      default: m(() => [...e[0] || (e[0] = [
        l("path", { d: "m13.106 12.99-.837-1.695a.3.3 0 0 0-.538 0l-.837 1.696a.3.3 0 0 1-.226.164l-1.87.272a.3.3 0 0 0-.167.511l1.354 1.32a.3.3 0 0 1 .086.266l-.32 1.863a.3.3 0 0 0 .436.316l1.673-.88a.3.3 0 0 1 .28 0l1.673.88a.3.3 0 0 0 .435-.316l-.32-1.864a.3.3 0 0 1 .087-.265l1.354-1.32a.3.3 0 0 0-.166-.511l-1.871-.272a.3.3 0 0 1-.226-.164" }, null, -1),
        l("path", {
          "fill-rule": "evenodd",
          d: "M3.217 4.328A1.25 1.25 0 0 1 4.325 2.5h3.872a1.25 1.25 0 0 1 1.108.672l2.52 4.83a7 7 0 0 1 .35 0l2.52-4.83A1.25 1.25 0 0 1 15.803 2.5h3.872a1.25 1.25 0 0 1 1.108 1.828l-3.348 6.418a6.75 6.75 0 1 1-10.87 0L3.217 4.328M8.045 4l2.207 4.229a6.7 6.7 0 0 0-2.6 1.358L4.737 4h3.308m8.303 5.587a6.7 6.7 0 0 0-2.6-1.358L15.956 4h3.308l-2.915 5.587M12 9.5A5.25 5.25 0 1 0 12 20a5.25 5.25 0 0 0 0-10.5",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
